function HelperCtrl() {
	this.isUA = this.isUA.bind(this);
	this.isMobile = this.isMobile.bind(this);
	this.isIE = this.isIE.bind(this);
}

// Property Extend
HelperCtrl.prototype.extend = function(ext1, ext2) {
	for (var property in ext2) {
		ext1[property] = ext2[property];
	}
	return ext1;
}

// is UserAgent true match
HelperCtrl.prototype.isUA = function(ua) {
	var _ua = window.navigator.userAgent.toLowerCase();
	var navi = _ua.indexOf(ua) !== -1;
	return navi;
}

// param check
HelperCtrl.prototype.param = function(param1, param2) {
	var paramCheck = typeof param1 === 'undefined' ? param2 : param1;
	return paramCheck;
}

// is mobile
HelperCtrl.prototype.isMobile = function() {
	var iOS = (this.isUA('iphone') || this.isUA('ipod'));
	var Android = (this.isUA('android') && this.isUA('mobile'));
	var WindowsPhone = (this.isUA('windows') && this.isUA('phone'));
	var AndroidOld = (this.isUA('dream') || this.isUA('cupcake'));
	var FirefoxOS = (this.isUA('firefox') && this.isUA('mobile'));
	var blackberry = this.isUA('blackberry');

	return (iOS || Android || WindowsPhone || AndroidOld || FirefoxOS || blackberry);
}

// is touch
HelperCtrl.prototype.isTouch = function() {
	var touchDevice = typeof window.ontouchstart !== 'undefined';
	return touchDevice;
}

// is rotate
HelperCtrl.prototype.isRotate = function() {
	return Math.abs(window.orientation === 90);
}

// is [Internet Explorer] version checked.
HelperCtrl.prototype.isIE = function() {
	var msie = (this.isUA('msie') || this.isUA('trident'));
	return msie;
}

export default HelperCtrl;